/* Yaniko — общо за двата конфигуратора: измерване и запазване на дизайн.

   Държи се отделно, защото и простият, и ПРО конфигураторът имат нужда от
   едно и също, а две копия на един и същ код се разминават още при първата
   поправка. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.YGKShared = api;
}(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  /* ============================== ИЗМЕРВАНЕ ============================== */

  /* Събитията чакат съгласие. Магазинът има известна беля с банера за бисквитки,
     затова тук нищо не тръгва, преди Shopify да каже, че има разрешение —
     а каквото се е насъбрало дотогава, се изпраща наведнъж щом го получим. */
  var queue = [];
  var watching = false;

  function allowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.analyticsProcessingAllowed !== 'function') return null; // още не знаем
      return cp.analyticsProcessingAllowed();
    } catch (e) {
      return null;
    }
  }

  function flush() {
    if (allowed() !== true) return;
    var pending = queue.splice(0, queue.length);
    pending.forEach(send);
  }

  function watch() {
    if (watching) return;
    watching = true;

    document.addEventListener('visitorConsentCollected', flush);

    // Банерът може да е отговорил още преди скриптът ни да се качи.
    var tries = 0;
    var t = setInterval(function () {
      if (allowed() !== null || ++tries > 40) {   // до 20 секунди
        clearInterval(t);
        flush();
      }
    }, 500);
  }

  /* Стандартните събития (AddToCart и т.н.) ги праща самият Shopify към Meta и
     GA4 — с eventID, който ги сдвоява със сървърните. Наше копие под същото име
     се брои втори път, затова нашите вървят под свое име. */
  var OWN_NAME = { add_to_cart: 'configurator_add_to_cart' };

  function send(ev) {
    var name = OWN_NAME[ev.name] || ev.name;
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, ev.params);
      } else if (Array.isArray(window.dataLayer)) {
        window.dataLayer.push(Object.assign({ event: name }, ev.params));
      }
    } catch (e) {}

    try {
      if (typeof window.fbq === 'function') window.fbq('trackCustom', name, ev.params);
    } catch (e) {}
  }

  /* Праща се веднъж на стъпка — без това не се знае къде се къса фунията. */
  function track(name, params) {
    // Събитие без име Meta трупа в „__missing_event“ — по-добре да не тръгва.
    if (typeof name !== 'string' || !name) return;
    var ev = { name: name, params: params || {} };
    if (allowed() === true) { send(ev); return; }
    queue.push(ev);
    if (queue.length > 40) queue.shift();
    watch();
  }

  /* Пази кои стъпки вече са отчетени, за да не се брои една и съща по два пъти
     при връщане назад. Може и съкратено — trackOnce('view_hub', {...}):
     тогава ключът е и име на събитието. */
  var seen = {};
  function trackOnce(key, name, params) {
    if (typeof name !== 'string') { params = name; name = key; }
    if (seen[key]) return;
    seen[key] = true;
    track(name, params);
  }

  /* ============================== ЗАПАЗВАНЕ НА ДИЗАЙН ============================== */

  var KLAVIYO_KEY = 'YfJzF8';
  var KLAVIYO_LIST = 'VBiBNQ';   // „Вътрешният кръг (Welcome)"

  /* Изоставена конфигурация е далеч по-лична от изоставена количка: човекът е
     направил нещо свое. Затова се записва целият дизайн и връзка към него —
     писмото после може да покаже точно тази гривна. */
  function saveDesign(opts) {
    var email = String(opts.email || '').trim();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      return Promise.reject(new Error('Провери имейла.'));
    }

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: {
                  'Дизайн №': opts.designNo || '',
                  'Код на дизайна': opts.code || '',
                  'Връзка към дизайна': opts.url || '',
                  'Цена на дизайна': opts.price || '',
                  'Конфигуратор': opts.builder || ''
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (r) {
      // Klaviyo връща 202 без тяло при успех.
      if (r.status === 202 || r.ok) return true;
      throw new Error('Klaviyo ' + r.status);
    });
  }

  /* ============================== ГРАД С ТЪРСЕНЕ ============================== */

  /* 257 града в падащо меню се скролват цяла вечност на телефон. Затова над
     истинския <select> стои поле: пишеш „Каз" и избираш „Казанлък". Изборът се
     записва обратно в select-а и пуска input/change, така че сметката не знае
     нищо за полето. Без JavaScript остава обикновеният select. */
  var pickerN = 0;

  function norm(s) {
    return String(s || '').toLowerCase().replace(/ё/g, 'е').replace(/^гр\.?\s*/, '').replace(/\s+/g, ' ').trim();
  }

  function cityPicker(select, cities, opts) {
    opts = opts || {};
    if (!select || !cities || !cities.length || select.__picker) return null;
    var id = 'ygk-city-' + (++pickerN);
    var wrap = document.createElement('div');
    wrap.className = 'ygk-city' + (opts.theme ? ' ygk-city--' + opts.theme : '');
    var input = document.createElement('input');
    input.type = 'text';
    input.className = select.className + ' ygk-city__input';
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('autocapitalize', 'words');
    input.setAttribute('spellcheck', 'false');
    input.setAttribute('enterkeyhint', 'done');
    input.placeholder = opts.placeholder || 'Започни да пишеш града';
    var list = document.createElement('ul');
    list.className = 'ygk-city__list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.hidden = true;

    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(input);
    wrap.appendChild(list);
    wrap.appendChild(select);
    select.hidden = true;
    select.tabIndex = -1;
    select.__picker = true;

    var keys = cities.map(function (c) { return norm(c.име); });
    // При празно поле: най-големите градове, после останалите по азбука.
    var byPop = cities.map(function (c, i) { return i; }).sort(function (a, b) { return (cities[b].нас || 0) - (cities[a].нас || 0); });
    var shown = [], active = -1;

    function current() { return cities[parseInt(select.value, 10)] || null; }
    function showValue() { var c = current(); input.value = c ? c.име : ''; }

    function matches(q) {
      if (!q) return byPop.slice(0, 12);
      var first = [], word = [], inside = [];
      keys.forEach(function (k, i) {
        if (k.indexOf(q) === 0) first.push(i);
        else if ((' ' + k).indexOf(' ' + q) >= 0 || k.indexOf('(' + q) >= 0) word.push(i);
        else if (q.length > 2 && k.indexOf(q) > 0) inside.push(i);
      });
      return first.concat(word, inside).slice(0, 40);
    }

    function paint() {
      list.innerHTML = '';
      if (!shown.length) {
        var none = document.createElement('li');
        none.className = 'ygk-city__none';
        none.textContent = opts.none || 'Няма такъв град. Родените на село избират най-близкия град.';
        list.appendChild(none);
      }
      shown.forEach(function (ci, n) {
        var c = cities[ci];
        var li = document.createElement('li');
        li.id = id + '-' + ci;
        li.className = 'ygk-city__opt' + (n === active ? ' is-active' : '');
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', String(ci === parseInt(select.value, 10)));
        var b = document.createElement('span');
        b.textContent = c.име;
        li.appendChild(b);
        if (c.обл && c.обл !== c.име) {
          var o = document.createElement('small');
          o.textContent = c.обл === 'София-град' ? 'София-град' : 'обл. ' + c.обл;
          li.appendChild(o);
        }
        // mousedown без фокус: иначе полето губи фокус преди клика и списъкът се затваря.
        li.addEventListener('mousedown', function (e) { e.preventDefault(); });
        li.addEventListener('click', function () { pick(ci); close(); });
        list.appendChild(li);
      });
      if (active >= 0) input.setAttribute('aria-activedescendant', id + '-' + shown[active]);
      else input.removeAttribute('aria-activedescendant');
    }

    function open(q) {
      shown = matches(norm(q));
      active = q && shown.length ? 0 : -1;
      paint();
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      var a = list.querySelector('.is-active');
      if (a) a.scrollIntoView({ block: 'nearest' });
    }
    function close() {
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    function pick(ci) {
      var changed = String(ci) !== select.value;
      select.value = String(ci);
      showValue();
      if (changed) {
        select.dispatchEvent(new Event('input', { bubbles: true }));
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    input.addEventListener('focus', function () {
      input.select();
      open('');
      // На телефон клавиатурата заема половината екран — вдигаме полето нагоре,
      // за да остане място за подсказките под него.
      if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) {
        setTimeout(function () {
          var top = input.getBoundingClientRect().top;
          if (top > 140) window.scrollBy({ top: top - 120, behavior: 'smooth' });
        }, 280);
      }
    });
    input.addEventListener('input', function () { open(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (list.hidden) { open(input.value); return; }
        if (!shown.length) return;
        active = e.key === 'ArrowDown' ? Math.min(shown.length - 1, active + 1) : Math.max(0, active - 1);
        paint();
        var a = list.querySelector('.is-active');
        if (a) a.scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (!list.hidden && active >= 0) { e.preventDefault(); pick(shown[active]); close(); input.blur(); }
      } else if (e.key === 'Escape') {
        showValue(); close();
      }
    });
    input.addEventListener('blur', function () {
      // Изписан точно (без значение малки/главни) — приемаме го; иначе връщаме избрания.
      var q = norm(input.value), hit = keys.indexOf(q);
      if (hit >= 0) pick(hit); else showValue();
      close();
    });
    select.addEventListener('change', showValue);

    showValue();
    return { input: input, set: function (ci) { pick(ci); } };
  }

  return {
    track: track,
    trackOnce: trackOnce,
    saveDesign: saveDesign,
    cityPicker: cityPicker
  };
}));
